<div class="calendar-shell">
  <!-- HEADER --------------------------------------------------------- -->
  <header class="calendar-header">
    <div class="nav-left">
      <button type="button" class="icon-btn" (click)="goPrev()">
        ‹
      </button>
      <button type="button" class="icon-btn" (click)="goToday()">
        Today
      </button>
      <button type="button" class="icon-btn" (click)="goNext()">
        ›
      </button>
    </div>

    <div class="title">
      {{ headerLabel }}
    </div>

    <div class="view-toggle">
      <button
        type="button"
        class="toggle-btn"
        [class.active]="viewMode === 'week'"
        (click)="setViewMode('week')"
      >
        Week
      </button>
      <button
        type="button"
        class="toggle-btn"
        [class.active]="viewMode === 'month'"
        (click)="setViewMode('month')"
      >
        Month
      </button>
    </div>
  </header>

  <!-- MAIN LAYOUT ---------------------------------------------------- -->
  <div class="calendar-layout">
    <!-- LEFT: CALENDAR GRID ------------------------------------------ -->
    <section class="calendar-pane">
      <div class="weekday-row">
        <div class="weekday">Sun</div>
        <div class="weekday">Mon</div>
        <div class="weekday">Tue</div>
        <div class="weekday">Wed</div>
        <div class="weekday">Thu</div>
        <div class="weekday">Fri</div>
        <div class="weekday">Sat</div>
      </div>

      <div
        class="days-grid"
        [class.days-grid--week]="viewMode === 'week'"
        [class.days-grid--month]="viewMode === 'month'"
      >
        <button
          *ngFor="let day of days"
          type="button"
          class="day-cell"
          [class.day-cell--outside]="viewMode === 'month' && !day.inCurrentMonth"
          [class.day-cell--today]="day.isToday"
          [class.day-cell--selected]="isSameDay(day.date, selectedDate)"
          (click)="selectDay(day)"
        >
          <div class="day-label-row">
            <span class="day-label">
              {{ day.label }}
            </span>

            <span *ngIf="day.hasNotes" class="notes-dot" aria-label="Has notes">
            </span>
          </div>

          <div class="day-subtext">
            <span *ngIf="day.isToday">Today</span>
          </div>

          <div class="day-legend">
            <span class="day-legend-item">
              <i class="fas fa-comments"></i>
              {{ day.conversationCount }}
            </span>
            <span class="day-legend-item">
              <i class="fas fa-note-sticky"></i>
              {{ day.notesCount }}
            </span>
          </div>
        </button>
      </div>
    </section>

    <!-- RIGHT: NOTES PANE -------------------------------------------- -->
    <section class="notes-pane">
      <header class="notes-header">
        <h3>{{ selectedDateLabel }}</h3>
      </header>

      <div class="notes-list" *ngIf="selectedDayNotes.length; else noNotes">
        <article *ngFor="let note of selectedDayNotes" class="note-item">
          <div class="note-meta">
            <span class="note-time">
              {{ note.createdAt | date: 'shortTime' }}
            </span>
            <button
              type="button"
              class="note-delete"
              (click)="deleteNote(note)"
            >
              ✕
            </button>
          </div>
          <div class="note-conversation" *ngIf="note.conversationTitle">
            <i class="fas fa-comments"></i>
            {{ truncateConversationTopic(note.conversationTitle) }}
          </div>
          <p class="note-text">
            {{ note.text }}
          </p>
        </article>
      </div>

      <ng-template #noNotes>
        <p class="notes-empty">
          No notes yet for this day. Add one below.
        </p>
      </ng-template>

      <form
        class="note-form"
        (ngSubmit)="addNote()"
        autocomplete="off"
      >
        <label class="note-label" for="noteConversationSelect">Conversation</label>
        <select
          id="noteConversationSelect"
          name="noteConversation"
          [(ngModel)]="newNoteConversationId"
          [disabled]="selectedDayConversations.length === 0"
        >
          <option value="">No conversation</option>
          <option *ngFor="let conv of selectedDayConversations" [value]="conv.id">
            {{ truncateConversationTopic(conv.title || 'Conversation') }}
          </option>
        </select>
        <p class="note-hint" *ngIf="selectedDayConversations.length === 0">
          No conversations found for this day.
        </p>

        <textarea
          [(ngModel)]="newNoteText"
          name="newNote"
          rows="3"
          placeholder="Write a note for this day…"
        ></textarea>

        <div class="note-actions">
          <button
            type="submit"
            class="primary-btn"
            [disabled]="!newNoteText.trim()"
          >
            Add note
          </button>
        </div>
      </form>
    </section>
  </div>
</div>
